import { createApi } from '@reduxjs/toolkit/query/react';
import { baseApiQuery } from '../basequery';

export interface BackendVersionInfo {
  apiVersion?: string;
  databaseVersion?: string;
}

export const versionApi = createApi({
  reducerPath: 'versionApi',
  baseQuery: baseApiQuery,
  endpoints: (builder) => ({
    /** Fetches backend (API and db) version information */
    getVersionInfo: builder.query<BackendVersionInfo, void>({
      query: () => ({ url: '/version', method: 'GET' }),
    }),
  }),
});

export const { useGetVersionInfoQuery } = versionApi;
